import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'click'
        }
    }

    init() {
    }

    click(e) {
        if(html.getAttribute('data-template') != 'home') return;

        this.call('toggle','MenuButton');
        this.call('scrollTo',e,'Scroll','main');
    }
}
